/** 来源：crm/foodbuy/market；统一为规范 03 的五种语义 tone。 */
export type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger'

/** 各 tone 的 soft 底色类，Badge / Alert（含 Toast）共用。
 *  注意只做常量组合、不做字符串拼接生成——Tailwind 需要扫描到完整类名字面量。 */
const toneSoftBackground: Record<Tone, string> = {
  neutral: 'bg-[var(--color-soft)]',
  info: 'bg-[var(--color-primary-soft)]',
  success: 'bg-[var(--color-success-soft)]',
  warning: 'bg-[var(--color-warning-soft)]',
  danger: 'bg-[var(--color-danger-soft)]'
}

const badgeToneText: Record<Tone, string> = {
  neutral: 'text-[var(--color-muted)]',
  info: 'text-[var(--color-primary)]',
  success: 'text-[var(--color-success-ink)]',
  warning: 'text-[var(--color-warning-ink)]',
  danger: 'text-[var(--color-danger-ink)]'
}

const alertToneBorder: Record<Tone, string> = {
  neutral: 'border-[var(--color-line)]',
  info: 'border-[var(--color-primary)]',
  success: 'border-[var(--color-success)]',
  warning: 'border-[var(--color-warning)]',
  danger: 'border-[var(--color-danger)]'
}

/** Alert 正文统一墨色（与标题同色），只随 tone 换边框与底色。 */
const alertText = 'text-[var(--color-ink)]'

export const badgeToneClasses: Record<Tone, string> = {
  neutral: `${toneSoftBackground.neutral} ${badgeToneText.neutral}`,
  info: `${toneSoftBackground.info} ${badgeToneText.info}`,
  success: `${toneSoftBackground.success} ${badgeToneText.success}`,
  warning: `${toneSoftBackground.warning} ${badgeToneText.warning}`,
  danger: `${toneSoftBackground.danger} ${badgeToneText.danger}`
}

export const alertToneClasses: Record<Tone, string> = {
  neutral: `${alertToneBorder.neutral} ${toneSoftBackground.neutral} ${alertText}`,
  info: `${alertToneBorder.info} ${toneSoftBackground.info} ${alertText}`,
  success: `${alertToneBorder.success} ${toneSoftBackground.success} ${alertText}`,
  warning: `${alertToneBorder.warning} ${toneSoftBackground.warning} ${alertText}`,
  danger: `${alertToneBorder.danger} ${toneSoftBackground.danger} ${alertText}`
}
